import React, {Component} from "react";
import {reduxForm} from "redux-form";
import {connect} from "react-redux";
import {Trans} from "react-i18next";
import MozillaVideoApp from "./MozillaVideoApp";

class ModalMozillaForm extends Component {

    render() {
        let instructions = [
            <span>Step 1: Install the extension&nbsp;
                <a href="https://addons.mozilla.org/firefox/addon/video-downloadhelper">
                 Video DownloadHelper
            <img src="/_core/assets/themes/transcription/assets/img/ext_mozilla.png"
                 alt="Video DownloadHelper"
                 width='16px'
                 height='16px'
            />
           </a>
        </span>,
            <span>Step 2: Click the button "Allow this extension to run in Private Windows" on the Mozilla Toolbar</span>,
            <span>Step 3: Refresh the media page and download the desired media on the Mozilla Toolbar</span>,
            <span>Step 4: Upload the downloaded media from your device to our website</span>,
        ];

        return <form>
            <span className="label center">
                <Trans>Instruction - How To Download A Private Media From The Mozilla Browser</Trans>
            </span>
            <MozillaVideoApp></MozillaVideoApp>
            <br></br>
            <td>
                {instructions.map(step => (
                    <li>
                        {step}
                    </li>
                ))}
            </td>
        </form>
    }
}

ModalMozillaForm = reduxForm({
    form: 'MozillaForm',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
})(ModalMozillaForm);

export default connect()(ModalMozillaForm);